/* eslint-disable no-restricted-syntax */
import { IVehicle } from "interfaces/session/IVehicle";
import { BOLD_POPULAR_MAKES, BOLD_POPULAR_MODELS } from "modules/site-structure/accessories-make/constant";

export const amplitudeVehiclePayloadChanger = (payload: IVehicle) => {
  let updatedPayload = { ...payload };
  if (!payload) {
    updatedPayload = {
      make: "NOT_PRESENT",
      model: "NOT_PRESENT",
      year: "NOT_PRESENT",
    };
  } else {
    for (const key in updatedPayload) {
      if (updatedPayload.hasOwnProperty(key)) {
        if (!updatedPayload[key]) {
          updatedPayload[key] = "NOT_PRESENT";
        }
      }
    }
  }

  return updatedPayload;
};

export function isPopularMake(make: string) {
  if (!make) {
    return false;
  }
  return BOLD_POPULAR_MAKES.some((el) => el.toLowerCase() === make.toLowerCase());
}

export function isPopularModel(model: string) {
  if (!model) {
    return false;
  }

  return BOLD_POPULAR_MODELS.some((el) => el.toLowerCase() === model.toLowerCase());
}
